module.exports = "/_next/static/files/3221436ffa0686b38bbab415aabf0601.svg";